/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SerieId202,
  DeleteApiV1SerieId401,
  DeleteApiV1SerieId404,
  DeleteApiV1SerieId500,
  DeleteApiV1SerieIdMutationResponse,
  DeleteApiV1SerieIdPathParams,
} from "../../types/serieRegistroController/DeleteApiV1SerieId.ts";

export const deleteApiV1SerieIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SerieIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SerieId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SerieId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1SerieId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SerieId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerieId500>;

export const deleteApiV1SerieIdMutationResponseSchema = z.lazy(
  () => deleteApiV1SerieId202Schema,
) as unknown as ToZod<DeleteApiV1SerieIdMutationResponse>;
